<ng-template #template>

@for (col of columns(); track col.field) {
    @if(!col.hide) {
      <th pResizableColumn [pResizableColumnDisabled]="col.frozen ?? false" pFrozenColumn [frozen]="col.frozen ?? false" 
      [pSortableColumn]="col.sortable ? col.field : undefined" 
      [ngClass]="col.headerClass"
      >
        <div class="flex items-center " 
        [class.justify-center]="col.type === 'chip'" 
        [class.justify-end]="col.type === 'currency' || col.type === 'number'"
        >
            <div class="" [pTooltip]="col.headerTooltip" [showDelay]="500">{{col.header}}</div>
            <div class="flex items-center">
                @if(col.sortable) {
                <p-sortIcon [style.display]="'flex'" [field]="col.field" />
                }
                @if(col.filterable) {
                <p-columnFilter [type]='filterType[col.type]' [field]="col.field" display="menu" />
                }


            </div>

        </div>

    </th>
    }
}

</ng-template>